import {MenuItem, TextField} from "@mui/material";
import React from "react";

const ShippingMethodsSelect = ({ label, value, onChange }) => {
    const shipingMethods = ["Retirada no local", "Produto digital (sem entrega)", "Motoboy", "Correios", "Transportadora", "Outros"];

    return (
        <TextField
            label={label}
            fullWidth
            select
            value={value}
            onChange={onChange}
        >
            {shipingMethods.map((method) => (
                <MenuItem key={method} value={method}>
                    {method}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default ShippingMethodsSelect